import React from 'react';

const AsyncCreateClientPage = React.lazy(() => import('./Container'));

export const ClientCreatePage = () => {
  return <AsyncCreateClientPage />;
};
